

// function getRecentlyViewedProducts() {
//   const productData = JSON.parse(localStorage.getItem("recentlyViewedProduct")) || [];
//   const main_product_handle = $("#main_product_handle").val();

//   if (!productData.length) return;

//   productData.forEach(function (item) {
//     if (item.productHandle === main_product_handle) return;

//     $(".recently_viewed__header").addClass("title-visible");

//     $.ajax({
//       url: "/products/" + item.productHandle + ".js",
//       dataType: "json",
//       success: function (product) {

//         let recentview_html = `
//           <li class="splide__slide recent-product-slide">
//             <div class="card-wrapper product-card-wrapper underline-links-hover card-grid">
//               <div class="card card--standard card--media" style="--ratio-percent:100%;">
                
//                 <div class="card__inner ratio" style="--ratio-percent:100%;">

//                  <!-- QUICK BUY OVER IMAGE -->
//                 <div class="pro-cart-button js-pro-cart-button">
//                 <a href="javascript:void(0)" 
//                     class="quick-buy-trigger"
//                     data-variant-id="${product.variants[0].id}">
//                     <svg width="11" height="13" viewBox="0 0 11 13" fill="none"
//                     xmlns="http://www.w3.org/2000/svg">
//                     <path d="M8 5.83333V3.16667C8 1.69391 6.88071 0.5 5.5 0.5C4.11929 0.5 3 1.69391 3 3.16667V5.83333M1.125 4.5H9.875L10.5 12.5H0.5L1.125 4.5Z"
//                         stroke="#705938" stroke-linecap="round" stroke-linejoin="round"/>
//                     </svg>
//                     <span class="button-text">Quick Buy</span>
//                 </a>
//                 </div>
//                   <div class="card__media">
//                     <div class="media media--transparent media--hover-effect">
//                       <a href="${product.url}">
//                         <img src="${product.featured_image}"
//                              alt="${product.title}"
//                              width="1200"
//                              height="1200"
//                              loading="lazy">
//                       </a>
//                     </div>
//                   </div>

//                   <div class="card__content">
//                     <div class="card__information">
//                       <h3 class="card__heading">
//                         <a href="${product.url}" class="full-unstyled-link">
//                           ${product.title}
//                         </a>
//                       </h3>
//                     </div>
//                   </div>
//                 </div>

//                 <div class="card__content">
//                   <div class="card__information">
//                     <h3 class="card__heading h5">
//                       <a href="${product.url}" class="full-unstyled-link">
//                         ${product.title}
//                       </a>
//                     </h3>

//                     <ul class="card-option">
//         `;

//         product.variants.forEach(function (variant) {
//           recentview_html += `
//             <li data-variant-id="${variant.id}">
//               <span class="opt-lable">${variant.title}</span>
//               <span class="opt-price">${Shopify.formatMoney(variant.price)}</span>
//             </li>
//           `;
//         });
// var quickAddId = `QuickAdd-${product.id}`;
//         recentview_html += `
//                     </ul>
//                   </div>

                 
//                     <!-- QUICK ADD (SHOPIFY MODAL) -->
//                     <div class="quick-add no-js-hidden hidden">
//                         <modal-opener data-modal="#${quickAddId}">
//                         <button
//                             id="quick-add-${product.id}-submit"
//                             type="submit"
//                             name="add"
//                             class="quick-add__submit button button--full-width button--secondary"
//                             aria-haspopup="dialog"
//                             aria-labelledby="quick-add-${product.id}-submit title-${product.id}"
//                            data-product-url="${product.url}?view=quick-add"f
//                         >
//                             Choose options

//                             <div class="loading__spinner hidden">
//                             <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66"
//                                 xmlns="http://www.w3.org/2000/svg">
//                                 <circle class="path" fill="none" stroke-width="6"
//                                 cx="33" cy="33" r="30"></circle>
//                             </svg>
//                             </div>
//                         </button>
//                         </modal-opener>

//                         <quick-add-modal id="${quickAddId}" 
//                           class="quick-add-modal"
//                           data-product-url="${product.url}?view=quick-add">
//                         <div
//                             role="dialog"
//                             aria-label="Choose options for ${product.title}"
//                             aria-modal="true"
//                             class="quick-add-modal__content global-settings-popup"
//                             tabindex="-1"
//                         >
//                             <button
//                             type="button"
//                             class="quick-add-modal__toggle"
//                             aria-label="Close"
//                             >
//                             <svg class="icon icon-close" width="24" height="24"
//                                 viewBox="0 0 24 24" fill="none"
//                                 xmlns="http://www.w3.org/2000/svg">
//                                 <path d="M18.75 6.81984L17.1802 5.25L12 10.4302L6.81984 5.25
//                                         L5.25 6.81984L10.4302 12L5.25 17.1802L6.81984 18.75
//                                         L12 13.5698L17.1802 18.75L18.75 17.1802
//                                         L13.5698 12L18.75 6.81984Z"
//                                 fill="black"></path>
//                             </svg>
//                             </button>

//                             <div id="QuickAddInfo-${product.id}"
//                                 class="quick-add-modal__content-info">
//                             </div>
//                         </div>
//                         </quick-add-modal>
//                     </div>
//                 </div>
//               </div>
//             </div>
//           </li>
//         `;

//         $(".recently-viewed-grid").append(recentview_html);
//         document.dispatchEvent(new CustomEvent("shopify:section:load"));
//       }
//     });
//   });
// }

// /* =============================
//    SWIPER INIT
// ============================= */
// function initRecentlyViewedSwiper() {
//   if (!$(".recently-viewed-swiper").length) return;

//   new Swiper(".recently-viewed-swiper", {
//     slidesPerView: 4,
//     spaceBetween: 20,
//     navigation: {
//       nextEl: ".swiper-button-next",
//       prevEl: ".swiper-button-prev"
//     },
//     breakpoints: {
//       1200: { slidesPerView: 4 },
//       992: { slidesPerView: 3 },
//       768: { slidesPerView: 2 },
//       575: { slidesPerView: 1 }
//     }
//   });
// }

// /* =============================
//    ADD TO CART
// ============================= */
// $(document).on("click", ".add-to-cart-recent", function () {
//   const variantId = $(this).data("variant-id");

//   $.ajax({
//     type: "POST",
//     url: "/cart/add.js",
//     data: {
//       id: variantId,
//       quantity: 1
//     },
//     dataType: "json",
//     success: function () {
//       window.location.href = "/cart";
//     },
//     error: function () {
//       alert("Product is sold out!");
//     }
//   });
// });
// /* =============================
//    QUICK BUY ICON → OPEN MODAL
// ============================= */
// document.addEventListener("click", function (e) {
//   const trigger = e.target.closest(".js-pro-cart-button");
//   if (!trigger) return;

//   const card = trigger.closest(".card");
//   if (!card) return;

//   const opener = card.querySelector("modal-opener button");
//   if (!opener) return;

//   opener.click(); 
// });
// /* =============================
//    INIT
// ============================= */
// document.addEventListener("DOMContentLoaded", function () {
//   getRecentlyViewedProducts();

//   setTimeout(function () {
//     const $wrapper = $(".recently-viewed-wrapper");
//     const $swiperContainer = $(".recently-viewed-swiper");
//     const slideCount = $swiperContainer.find(".splide__slide").length;

  
//     if (slideCount < 1) {
//       $wrapper.addClass("hidden");
//       return;
//     }

  
//     $wrapper.removeClass("hidden");

 
//     if (slideCount > 3) {
//       initRecentlyViewedSwiper();
//     } else {
   
//       $swiperContainer.removeClass("swiper");
//       $(".swiper-button-next, .swiper-button-prev").hide();
//     }

//   }, 1500);
// });




function getRecentlyViewedProducts() {
  const productData = JSON.parse(localStorage.getItem("recentlyViewedProduct")) || [];
  const main_product_handle = $("#main_product_handle").val();

  if (!productData.length) return;

  productData.forEach(function (item) {
    if (item.productHandle === main_product_handle) return;

    $(".recently_viewed__header").addClass("title-visible");

    $.ajax({
      url: "/products/" + item.productHandle + ".js",
      dataType: "json",
      success: function (product) {
        let recentview_html = `
          <div class="splide__slide recent-product-slide">
            <div class="card-wrapper product-card-wrapper underline-links-hover card-grid">
              <div class="card card--standard card--media" style="--ratio-percent:100%;">
                
                <div class="card__inner ratio" style="--ratio-percent:100%;">

                 <!-- QUICK BUY OVER IMAGE -->
                <div class="pro-cart-button js-pro-cart-button">
                <a href="javascript:void(0)" 
                    class="quick-buy-trigger"
                    data-variant-id="${product.variants[0].id}">
                    <svg width="11" height="13" viewBox="0 0 11 13" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path d="M8 5.83333V3.16667C8 1.69391 6.88071 0.5 5.5 0.5C4.11929 0.5 3 1.69391 3 3.16667V5.83333M1.125 4.5H9.875L10.5 12.5H0.5L1.125 4.5Z"
                        stroke="#705938" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <span class="button-text">Quick Buy</span>
                </a>
                </div>
                  <div class="card__media">
                    <div class="media media--transparent media--hover-effect">
                      <a href="${product.url}">
                        <img src="${product.featured_image}"
                             alt="${product.title}"
                             width="1200"
                             height="1200"
                             loading="lazy">
                      </a>
                    </div>
                  </div>

                  <div class="card__content">
                    <a href="${product.url}" class="pro-img-link"></a>
                    <div class="card__information">
                      <h3 class="card__heading">
                        <a href="${product.url}" class="full-unstyled-link">
                          ${product.title}
                        </a>
                      </h3>
                    </div>
                  </div>
                </div>

                <div class="card__content">
                  <div class="card__information">
                    <h3 class="card__heading h5">
                      <a href="${product.url}" class="full-unstyled-link">
                        ${product.title}
                      </a>
                    </h3>

                    <ul class="card-option">
        `;

        product.variants.forEach(function (variant) {
          recentview_html += `
            <li data-variant-id="${variant.id}">
              <span class="opt-lable">${variant.title}</span>
              <span class="opt-price">${Shopify.formatMoney(variant.price)}</span>
            </li>
          `;
        });

        recentview_html += `
                    </ul>
                  </div>

                  <!-- QUICK ADD (SHOPIFY MODAL) -->
                  <div class="quick-add hidden no-js-hidden">
                    <modal-opener data-modal="#QuickAdd-${product.id}">
                      <button
                        id="quick-add-${product.id}-submit"
                        type="submit"
                        name="add"
                        class="quick-add__submit button button--full-width button--secondary"
                        aria-haspopup="dialog"
                        aria-labelledby="quick-add-${product.id}-submit title-${product.id}"
                        data-product-url="${product.url}?view=quick-add"
                      >
                        Choose options
                        <div class="loading__spinner hidden">
                          <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                            <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                          </svg>
                        </div>
                      </button>
                    </modal-opener>
                  </div>
                </div>
              </div>
            </div>
          </div>
        `;

        // APPEND THE MODAL SEPARATELY (OUTSIDE THE SWIPER)
        const modalHTML = `
          <quick-add-modal id="QuickAdd-${product.id}" class="quick-add-modal">
            <div role="dialog" aria-label="Choose options for ${product.title}" aria-modal="true" class="quick-add-modal__content global-settings-popup" tabindex="-1">
              <button id="ModalClose-${product.id}" type="button" class="quick-add-modal__toggle" aria-label="Close">
                <svg class="icon icon-close" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18.75 6.81984L17.1802 5.25L12 10.4302L6.81984 5.25L5.25 6.81984L10.4302 12L5.25 17.1802L6.81984 18.75L12 13.5698L17.1802 18.75L18.75 17.1802L13.5698 12L18.75 6.81984Z" fill="black"></path>
                </svg>
              </button>
              <div id="QuickAddInfo-${product.id}" class="quick-add-modal__content-info"></div>
            </div>
          </quick-add-modal>
        `;

        // Append modal to body (not inside swiper)
        $("body").append(modalHTML);
        $(".recently-viewed-grid").append(recentview_html);
        
        // Initialize the modal functionality
        setTimeout(() => {
          // Trigger shopify section load event
          document.dispatchEvent(new CustomEvent("shopify:section:load"));
          
          // Make sure custom element is upgraded
          customElements.upgrade(document.querySelector(`#QuickAdd-${product.id}`));
        }, 100);
      }
    });
  });
}
/* =============================
   INITIALIZE QUICK ADD MODAL
============================= */
function initQuickAddModal(product, modalId) {
  const modal = document.getElementById(modalId);
  const contentDiv = modal.querySelector(`#QuickAddInfo-${product.id}`);
  
  if (!modal || !contentDiv) return;

  // Close button functionality
  const closeButton = modal.querySelector(`#ModalClose-${product.id}`);
  if (closeButton) {
    closeButton.addEventListener('click', () => {
      modal.removeAttribute('open');
    });
  }

  // Modal opener functionality
  const modalOpener = document.querySelector(`[data-modal="#${modalId}"] button`);
  if (modalOpener) {
    modalOpener.addEventListener('click', (e) => {
      e.preventDefault();
      
      // Show loading state
      const loadingHTML = `
        <div class="quick-add-loading" style="text-align: center; padding: 40px;">
          <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
            <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
          </svg>
          <p>Loading product details...</p>
        </div>
      `;
      contentDiv.innerHTML = loadingHTML;
      
      // Load quick-add content via AJAX
      fetch(`${product.url}?view=quick-add`)
        .then(response => response.text())
        .then(html => {
          contentDiv.innerHTML = html;
          modal.setAttribute('open', '');
          
          // Re-initialize any scripts
          document.dispatchEvent(new CustomEvent("shopify:section:load"));
          
          // Close modal when clicking outside
          modal.addEventListener('click', (e) => {
            if (e.target === modal) {
              modal.removeAttribute('open');
            }
          });
        })
        .catch(error => {
          console.error('Error loading quick-add content:', error);
          contentDiv.innerHTML = '<p>Error loading product. Please try again.</p>';
        });
    });
  }

  // Close modal with ESC key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.hasAttribute('open')) {
      modal.removeAttribute('open');
    }
  });
}

/* =============================
   SWIPER INIT
============================= */
// function initRecentlyViewedSwiper() {
//   if (!$(".recently-viewed-swiper").length) return;

//   new Swiper(".recently-viewed-swiper", {
//     slidesPerView: 4,
//     spaceBetween: 0,
//      scrollbar: {
//       draggable: true,
//       // el: ".swiper-scrollbar"
//     },
//     navigation: {
//       nextEl: ".swiper-button-next",
//       prevEl: ".swiper-button-prev"
//     },
//     breakpoints: {
//       1200: { slidesPerView: 4 },
//       992: { slidesPerView: 3 },
//       768: { slidesPerView: 2 },
//       575: { slidesPerView: 1 }
//     }
//   });
// }
// function initRecentlyViewedSwiper() {
//   if (!$(".recently-viewed-swiper").length) return;

//   new Swiper(".recently-viewed-swiper", {
//     slidesPerView: 1,  // Start with 1 for smallest screens
//     spaceBetween: 0,  // Add spacing for better touch interaction
//     scrollbar: {
//       draggable: true,
//       // el: ".swiper-scrollbar"
//     },
//     navigation: {
//       nextEl: ".swiper-button-next",
//       prevEl: ".swiper-button-prev"
//     },
//     // Breakpoints from smallest to largest
//     breakpoints: {
//        412: { 
//         slidesPerView: 1,
//         spaceBetween: 0
//       },
//       575: { 
//         slidesPerView: 1,
//         spaceBetween: 0
//       },
//       768: { 
//         slidesPerView: 1,
//         spaceBetween: 0
//       },
//       992: { 
//         slidesPerView: 1,
//         spaceBetween: 0
//       },
//       1200: { 
//         slidesPerView: 1,
//         spaceBetween: 0,
//          scrollbar: {
//       draggable: true,
//       // el: ".swiper-scrollbar"
//     }
//       }
//     }
//   });
// }
function initRecentlyViewedSwiper() {
  if (!$(".recently-viewed-swiper").length) return;

  // new Swiper(".recently-viewed-swiper", {
  // slidesPerView: "auto", // ✅ KEY FIX
  // spaceBetween: 0,
  // freeMode: false,
  // loop: false,
  // scrollbar: {
  //   // el: ".block_scrollbar.swiper-scrollbar",
  //   draggable: true,
  // },
  // navigation: {
  //   nextEl: ".swiper-button-next",
  //   prevEl: ".swiper-button-prev",
  // },
  // breakpoints: {
  //   0: {
  //     slidesPerView: "auto",
  //   },
  // },
  // });

  if (document.querySelector('.product-slider-recently')) {
    // Video splide slider
    const product_slider_splide = new Splide('.product-slider-recently', {
        start: 1,
        autoWidth: true,
        perMove: 3,
        gap: 16,
        type: "loop",
        drag: "free",
        snap: false,
        interval: 3000,
        arrows: true,
        pagination: true,
        rewind: true,
        rewindByDrag: true,
        lazyLoad: true,
        breakpoints: {          
            640: {
                gap: 8,
                autoWidth: true,
                snap: true
            }
        }
    });
    product_slider_splide.mount();
    }
}



/* =============================
   ADD TO CART
============================= */
$(document).on("click", ".add-to-cart-recent", function () {
  const variantId = $(this).data("variant-id");

  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: {
      id: variantId,
      quantity: 1
    },
    dataType: "json",
    success: function () {
      window.location.href = "/cart";
    },
    error: function () {
      alert("Product is sold out!");
    }
  });
});

/* =============================
   QUICK BUY ICON → OPEN MODAL
============================= */
document.addEventListener("click", function (e) {
  const trigger = e.target.closest(".js-pro-cart-button");
  if (!trigger) return;

  const card = trigger.closest(".card");
  if (!card) return;

  const opener = card.querySelector("modal-opener button");
  if (!opener) return;

  opener.click(); 
});

/* =============================
   INIT
============================= */
document.addEventListener("DOMContentLoaded", function () {
  getRecentlyViewedProducts();

  setTimeout(function () {
    const $wrapper = $(".recently-viewed-wrapper");
    const $swiperContainer = $(".recently-viewed-swiper");
    const slideCount = $swiperContainer.find(".splide__slide").length;

    if (slideCount < 1) {
      $wrapper.addClass("hidden");
      return;
    }

    $wrapper.removeClass("hidden");

    if (slideCount > 1) {
      initRecentlyViewedSwiper();
    } else {
      $swiperContainer.removeClass("swiper");
      $(".swiper-button-next, .swiper-button-prev").hide();
    }

  }, 1500);
});

// document.addEventListener("DOMContentLoaded", function () {
//   getRecentlyViewedProducts();

//   setTimeout(function () {
//     const $wrapper = $(".recently-viewed-wrapper");
//     const $swiperContainer = $(".recently-viewed-swiper");
//     const slideCount = $swiperContainer.find(".splide__slide").length;

//     if (slideCount < 1) {
//       $wrapper.addClass("hidden");
//       return;
//     }

//     $wrapper.removeClass("hidden");

//     // Initialize swiper if there are more than 3 slides
//     if (slideCount > 2) {
//       initRecentlyViewedSwiper();
//     } else {
//       // For 1-3 items, remove swiper classes and hide navigation
//       $swiperContainer.removeClass("swiper");
//       $(".recently-viewed-grid").removeClass("swiper-wrapper");
//       $(".swiper-button-next, .swiper-button-prev, .swiper-scrollbar").hide();
//     }

//   }, 2000); // Increased timeout to ensure products load
// });